module.exports = __webpack_public_path__ + "static/media/Total_Order.4c9f9f41.svg";